module.exports = __webpack_public_path__ + "523294be1d59a10384f7ae1cd889d217.svg";